module.exports = __webpack_public_path__ + "img/msg_phone_bg.fbef0ea1.png";